import { Icon, message, Tooltip } from 'antd'
import React, { useState } from 'react'
import { downloadS3Url } from 'src/utils/utils';
export interface IDownloadDocument {
  tooltip: string;
  url: string;
  filename: string;
  progressMessage?: string;
  downloadUsingfetch?: boolean;
}

export function DownloadDocument(props: IDownloadDocument) {
  const { tooltip, url, filename, downloadUsingfetch  } = props;

  const downloadFileUsingfetch = async () => {
    // try to download the file using fetch api to preserve file name
    // it's an experimental method may not work in all browsers due to security reasons
    // Gaurav Kumar Tested (16-10-2023) on following browsers Chrome v117, FireFox v118.
    try {
      const data = await fetch(url); // download the file using fetch api
      const blobData = await data.blob(); // create a blob object containing the data from the file
      const urlX = window.URL.createObjectURL(blobData); // create a temporary URL
      const link = document.createElement('a'); // create a link element
      link.href = urlX; // set the href of the link to the temporary URL
      link.download = filename; //  set the download attribute to the given file name
      link.click(); // start download
    } catch {
      // if there is an error catch it and use fallback old method to download the file
      // filename may differ - browser dependent
      downloadS3Url(url, filename);
    }
  };


  return (
    <Tooltip title={tooltip} placement="left">
      <Icon
        style={{ cursor: 'pointer' }}
        type="download"
        onClick={() => {
          message.loading(props?.progressMessage || 'File downloadeding ...');
          downloadUsingfetch ? downloadFileUsingfetch() : downloadS3Url(url, filename);
        }}
      />
    </Tooltip>
  );
}
